import { useUserQuery } from './useUserQuery';
import { useUsersQuery } from './useUsersQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface CoreUserDisableMutationParams {
  id: string;
}

export const useCoreUserDisableMutation = createMutationHook(
  'settings.teamPermissions.userDisable',
  (params: CoreUserDisableMutationParams) => ({
    coreUserDisable: {
      __args: {
        id: params.id,
      },
    },
  }),
  {
    invalidateQueries: [useUserQuery, useUsersQuery],
  },
);
